module.exports = __webpack_public_path__ + "static/media/18.74117c81.jpeg";